import _ from '@lodash';
import { Typography, withStyles } from '@material-ui/core';
import { TimerOutlined } from "@material-ui/icons";
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import React from 'react';
import XAPPButton from '../Button/XAPPButton';

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
        '& select, input': {
            backgroundColor: theme.palette.background.paper + " !important"
        }
    }
});

class PaginadorApp extends XAPPComponent {

    state = {
        pagina: 0
    }

    componentDidUpdate(prevProps, prevState) {
        // if (prevProps.data.length > 0 && prevProps.data.length < this.props.data.length) {
        //     this.changePagina(this.state.pagina + 1);
        // }

        if (!_.isEqual(prevState, this.state) && this.state.pagina !== this.props.page) {
            this.props.onPageChange(this.state.pagina);
        }
    }

    changePagina = (_APagina) => {
        this.setState(_.set({ ...this.state }, "pagina", _APagina));
    }

    render() {
        const { nextPage, paginas = 1, pagina = 1, page } = this.props;
        var APagina = page + 1;
        return (
            <React.Fragment>
                <div className="flex flex-col w-full items-center">
                    <div className="flex items-center text-center">
                        <XAPPButton
                            type="Icon"
                            className=""
                            disabled={page === 0}
                            onClick={() => {
                                this.changePagina(this.state.pagina - 1);
                            }}
                            iconProps={"justify-end"}
                            icon={"arrow_left"}
                            key={"iconPaginadorLeft"}
                        />
                        <Typography>{APagina + " de " + paginas}</Typography>
                        <XAPPButton
                            type="Icon"
                            className=""
                            disabled={APagina === paginas}
                            onClick={() => {
                                if (pagina < paginas) {
                                    nextPage();
                                    window.setTimeout(() => {
                                        this.changePagina(this.state.pagina + 1);
                                    }, 1500);
                                }
                                else {
                                    this.changePagina(this.state.pagina + 1);
                                }
                            }}
                            iconProps={"justify-end"}
                            icon={"arrow_right"}
                            key={"iconPaginadorRight"}
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}


export default withStyles(styles, { withTheme: true })(PaginadorApp);
